module.exports = __webpack_public_path__ + "static/kartchen-raumnutzung-offentlich3-3f56b41b3437acf2c673ee321d69a1e2.png";